import { ClinicSelectorOption } from './interface';
import { useClinics } from './useClinics';
import { createOptions, getSelectedOption } from './utils';

interface UseClinicOptionsProps {
  selectedClinicsId: string;
}

interface UseClinicOptionsReturn {
  options: ClinicSelectorOption[];
  selectedOptions?: ClinicSelectorOption[];
}

function useClinicOptions({
  selectedClinicsId
}: UseClinicOptionsProps): UseClinicOptionsReturn {
  const { clinics } = useClinics();
  const selectedOptions = getSelectedOption(selectedClinicsId, clinics);

  return {
    options: createOptions(clinics),
    selectedOptions
  };
}

export default useClinicOptions;
